import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import * as yup from 'yup';
import { RendererType } from '../data-models/field-definition';
import { ISimpleChoice } from '../data-models/field2.data-model';
import { isMoveAllowed } from '../services/hooks/useListActions';
import { listsStateJ } from '../services/state/ListsStateJ';

export function moveListCompanyPayloadFields() {
  return {
    companyIds: yup.array().of(yup.number().required()).required(),
    sourceListId: yup.number().required(),
    targetListId: yup.number().required(),
  };
}

export function moveListCompanyPayloadSchema() {
  return yup.object(moveListCompanyPayloadFields());
}

export type MoveListCompanyPayload = yup.InferType<ReturnType<typeof moveListCompanyPayloadSchema>>;

export function useMoveListCompanyFormSchema(sourceListId: number) {
  const { targetListId } = moveListCompanyPayloadFields();
  const allLists = useAtomValue(listsStateJ);
  const options: ISimpleChoice<number>[] = useMemo(() => {
    return (allLists ?? [])
      .filter((l) => l.id !== sourceListId && isMoveAllowed(l))
      .map((list) => ({
        displayName: list.name,
        value: list.id,
      }))
      .sort((a, b) => a.displayName.localeCompare(b.displayName));
  }, [allLists, sourceListId]);

  return yup.object({
    targetListId: targetListId
      .nullable()
      .default(null)
      .required()
      .label('List')
      .formMeta({
        renderer: RendererType.singleSelect,
        rendererMeta: {
          values: options,
        },
        disableClearable: true,
      }),
  });
}
